import { Button } from "@nwga/ui/components/button";
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuTrigger,
} from "@nwga/ui/components/dropdown-menu";
import { type Theme, useTheme } from "@nwga/ui/hooks/use-theme";
import { MonitorIcon, MoonIcon, SunIcon } from "lucide-react";

const OPTIONS: { value: Theme; label: string; icon: typeof SunIcon }[] = [
	{ value: "light", label: "Light", icon: SunIcon },
	{ value: "dark", label: "Dark", icon: MoonIcon },
	{ value: "system", label: "System", icon: MonitorIcon },
];

export function ThemeToggle() {
	const { theme, resolvedTheme, setTheme } = useTheme();
	const Icon = resolvedTheme === "dark" ? MoonIcon : SunIcon;

	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<Button variant="ghost" size="icon" aria-label="Change theme">
					<Icon className="size-4" />
				</Button>
			</DropdownMenuTrigger>
			<DropdownMenuContent align="end">
				{OPTIONS.map((option) => (
					<DropdownMenuItem
						key={option.value}
						onSelect={() => setTheme(option.value)}
						data-active={theme === option.value}
						className="data-[active=true]:font-medium"
					>
						<option.icon className="size-4" />
						{option.label}
					</DropdownMenuItem>
				))}
			</DropdownMenuContent>
		</DropdownMenu>
	);
}
